import React, { useContext } from 'react';
import {
	ICustomerFullInfoContext,
	CustomerFullInfoContext,
} from '../../../../../../customerFullInfoState/customerFullInfoContext';
import Sidebar from './components/Sidebar/Sidebar';
import LanguageBar from './components/LanguageBar/LanguageBar';
import StyleFields from 'components/StyleFields/StyleFields';
import MediaFields from './components/MediaFields/MediaFields';
import DocumentSettings from './components/DocumentSettings/DocumentSettings';
import NoData from 'components/NoResultsFound/NoData';
import classNames from 'classnames';
import style from './StyleTab.module.scss';

const StyleTab: React.FC = () => {
	const { styleData, customerFullInfoVisibleForm, selectedStyleGroup } =
		useContext<ICustomerFullInfoContext>(CustomerFullInfoContext);
	const containerClasses = classNames(style.container, {
		[style.visible]: customerFullInfoVisibleForm === 'styleForm',
	});

	// TODO delete later
	const functionStub = () => {
		console.log();
	};
	// TODO delete later

	return (
		<div className={containerClasses} data-test="StyleTab">
			{styleData ? (
				<>
					{styleData.mediaSettings.length ? (
						<>
							<div className={style.sidebar}>
								<Sidebar />
							</div>
							<div className={style.content}>
								<div className={style.languageBar}>
									<LanguageBar />
								</div>
								<>
									<div className={style.inputsWrapper}>
										<StyleFields
											selectedGroup={selectedStyleGroup}
											setStyleSettings={functionStub}
											styleSettingColors={styleData.styleSettingColors}
											useForFullInfo={true}
										/>
									</div>
									{styleData.mediaSettings.map((el) => (
										<MediaFields data={el} key={el.languageId} />
									))}
									{styleData.documentSettings.map((el) => (
										<div className={style.fieldsWrapper} key={el.key}>
											<DocumentSettings data={el} />
										</div>
									))}
								</>
							</div>
						</>
					) : (
						<NoData />
					)}
				</>
			) : null}
		</div>
	);
};

export default StyleTab;
